import React, { useState, useMemo, useEffect } from 'react';

/**
 * Filter Type 1 — Single selection list filter with checkbox items.
 * Search input + checkbox list + Clear/Filter buttons.
 * Used for ALL columns (Filter Type 2 / DmsTextFilter is kept but not currently used).
 */
const DmsListFilter = ({ options, currentFilter, onApply, onClear, alignRight }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedValues, setSelectedValues] = useState(currentFilter?.values || []);

    useEffect(() => {
        setSelectedValues(currentFilter?.values || []);
    }, [currentFilter]);

    const filteredOptions = useMemo(() => {
        if (!searchTerm.trim()) return options;
        return options.filter(v => String(v).toLowerCase().includes(searchTerm.toLowerCase()));
    }, [options, searchTerm]);

    const toggleValue = (val) => {
        setSelectedValues(prev =>
            prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
        );
    };

    const handleFilter = () => {
        if (selectedValues.length > 0) {
            onApply({ type: 'list', values: selectedValues });
        } else {
            onClear();
        }
    };

    const handleClear = () => {
        setSearchTerm('');
        setSelectedValues([]);
        onClear();
    };

    return (
        <div className={`dms-filter-popup ${alignRight ? 'dms-filter-popup-right' : ''}`} onClick={e => e.stopPropagation()}>
            {/* Search input */}
            <input
                type="text"
                className="dms-filter-search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
            />

            {/* Checkbox list */}
            <div className="dms-filter-list-items">
                {filteredOptions.length === 0 ? (
                    <div className="dms-filter-no-options">No options available</div>
                ) : (
                    filteredOptions.map(val => (
                        <label key={val} className="dms-filter-checkbox-item">
                            <input
                                type="checkbox"
                                checked={selectedValues.includes(val)}
                                onChange={() => toggleValue(val)}
                            />
                            <span className="dms-filter-checkbox-label">{val}</span>
                        </label>
                    ))
                )}
            </div>

            {/* Action buttons */}
            <div className="dms-filter-actions">
                <button className="dms-filter-btn-clear" onClick={handleClear}>Clear</button>
                <button className="dms-filter-btn-apply" onClick={handleFilter}>Filter</button>
            </div>
        </div>
    );
};

export default DmsListFilter;